// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const VideoPlayButton: React.FC<{
    size?: number;
    color1?: string;
    color2?: string;
    className?: string;
}> = ({ size = 64, color1 = "#eee", className }) => (
    <svg className={className} focusable="false" viewBox="0 0 64 64" width={size} height={size}>
        <g fill="none" fillRule="evenodd">
            <circle cx="32" cy="32" r="31.5" fill={color1} opacity=".8" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M27.64 23.108a.76.76 0 0 0-.76-.014.75.75 0 0 0-.385.656v16.5a.753.753 0 0 0 1.144.642l13.5-8.25A.75.75 0 0 0 41.5 32a.76.76 0 0 0-.36-.642zm-1.492-1.322a2.25 2.25 0 0 1 2.274.042l13.5 8.25a2.25 2.25 0 0 1 0 3.844l-13.5 8.25a2.24 2.24 0 0 1-2.274.042A2.25 2.25 0 0 1 25 40.25v-16.5c0-.816.44-1.566 1.148-1.964"
            />
        </g>
    </svg>
);

export const videoPlayButtonString =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle cx='32' cy='32' r='31.5' fill='%23eee' fill-opacity='.8'/%3E%3Cpath fill='%23577538' fill-rule='nonzero' d='M27.64 23.108a.76.76 0 0 0-.76-.014.75.75 0 0 0-.385.656v16.5a.753.753 0 0 0 1.144.642l13.5-8.25A.75.75 0 0 0 41.5 32a.76.76 0 0 0-.36-.642zm-1.492-1.322a2.25 2.25 0 0 1 2.274.042l13.5 8.25a2.25 2.25 0 0 1 0 3.844l-13.5 8.25a2.24 2.24 0 0 1-2.274.042A2.25 2.25 0 0 1 25 40.25v-16.5c0-.816.44-1.566 1.148-1.964'/%3E%3C/g%3E%3C/svg%3E";

export const videoPlayButtonHoverString =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Ccircle cx='32' cy='32' r='31.5' fill='%23eee' fill-opacity='.8'/%3E%3Cpath fill='%2382AE56' fill-rule='nonzero' d='M27.64 23.108a.76.76 0 0 0-.76-.014.75.75 0 0 0-.385.656v16.5a.753.753 0 0 0 1.144.642l13.5-8.25A.75.75 0 0 0 41.5 32a.76.76 0 0 0-.36-.642zm-1.492-1.322a2.25 2.25 0 0 1 2.274.042l13.5 8.25a2.25 2.25 0 0 1 0 3.844l-13.5 8.25a2.24 2.24 0 0 1-2.274.042A2.25 2.25 0 0 1 25 40.25v-16.5c0-.816.44-1.566 1.148-1.964'/%3E%3C/g%3E%3C/svg%3E";

export default React.memo(VideoPlayButton);
